import { Button, Card, CardBody, CardHeader, Col, Input, Label, ListGroup, ListGroupItem, Row } from 'reactstrap';
import * as React from 'react';
import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { FileContext } from './FileContext';
import { FaPlus, FaTimes } from 'react-icons/fa';

interface IProps {
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

export const ProfessionalSupports = (props: IProps) => {
  const fileContext = useContext(FileContext);
  const [changedProfessionalSupportsLength, setChangedProfessionalSupportsLength] = useState(0);
  let ref: any = undefined;

  useEffect(() => {
    if (changedProfessionalSupportsLength > 0) {
      var elmnt = document.getElementById('add-new-professional-support');
      if (elmnt) {
        elmnt.scrollIntoView({ behavior: 'smooth' });
        ref.focus();
      }
    }
  }, [changedProfessionalSupportsLength]);

  return (
    <>
      <Card>
        <CardHeader className={'d-flex align-items-center'}>Professional Supports</CardHeader>
        <CardBody className={'p-0'}>
          <ListGroup flush={true}>
            {fileContext.professionalSupports.length > 0 && (
              <ListGroupItem className={'py-2 d-none d-md-block'}>
                <Row style={{ paddingRight: 42 }} className='row--condensed'>
                  <Col md={3}>
                    <Label>Name</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Profession</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Contact Information</Label>
                  </Col>
                  <Col md={3}>
                    <Label>Details</Label>
                  </Col>
                </Row>
              </ListGroupItem>
            )}
            {fileContext.professionalSupports.map((ps, index) => (
              <ListGroupItem key={ps.professionalSupportId} className='list-group-item--borderless'>
                <div className={'d-flex'}>
                  <Row className={'flex-grow-1 row--condensed'}>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Name</Label>
                      <Input
                        type='text'
                        ref={(r) => {
                          ref = r;
                        }}
                        value={ps.name}
                        onChange={(e) => {
                          const nameTemp = e.target.value;
                          fileContext.setProfessionalSupports((oldPS) => [
                            ...oldPS.slice(0, index),
                            { ...oldPS[index], name: nameTemp },
                            ...oldPS.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Profession</Label>
                      <Input
                        type='text'
                        value={ps.profession}
                        onChange={(e) => {
                          const professionTemp = e.target.value;
                          fileContext.setProfessionalSupports((oldPS) => [
                            ...oldPS.slice(0, index),
                            { ...oldPS[index], profession: professionTemp },
                            ...oldPS.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Contact Information</Label>
                      <Input
                        type='text'
                        value={ps.contactInformation}
                        onChange={(e) => {
                          const contactInformationTemp = e.target.value;
                          fileContext.setProfessionalSupports((oldPS) => [
                            ...oldPS.slice(0, index),
                            { ...oldPS[index], contactInformation: contactInformationTemp },
                            ...oldPS.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label className={'d-md-none'}>Details</Label>
                      <Input
                        type='text'
                        value={ps.details}
                        onChange={(e) => {
                          const detailsTemp = e.target.value;
                          fileContext.setProfessionalSupports((oldPS) => [
                            ...oldPS.slice(0, index),
                            { ...oldPS[index], details: detailsTemp },
                            ...oldPS.slice(index + 1),
                          ]);
                          props.setIsDirty(true);
                        }}
                      />
                    </Col>
                    <Col className={'d-md-none mt-3'}>
                      <Button
                        color='danger'
                        className='w-mobile-100'
                        onClick={() => {
                          props.setIsDirty(true);
                          fileContext.setProfessionalSupports((oldPS) => [
                            ...oldPS.slice(0, index),
                            ...oldPS.slice(index + 1),
                          ]);
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>

                  <div className={'d-none d-md-block'} style={{ width: 42 }}>
                    <Button
                      color={'link'}
                      className={'text-danger'}
                      onClick={() => {
                        props.setIsDirty(true);
                        fileContext.setProfessionalSupports((oldPS) => [
                          ...oldPS.slice(0, index),
                          ...oldPS.slice(index + 1),
                        ]);
                      }}
                    >
                      <FaTimes />
                    </Button>
                  </div>
                </div>
              </ListGroupItem>
            ))}
            <ListGroupItem
              tag={'button'}
              id={'add-new-professional-support'}
              className='border-top'
              onClick={() => {
                props.setIsDirty(true);
                fileContext.setProfessionalSupports((f) =>
                  f.concat([
                    {
                      professionalSupportId: Math.random().toString(),
                      name: '',
                      profession: '',
                      contactInformation: '',
                      details: '',
                    },
                  ])
                );
                setChangedProfessionalSupportsLength((f) => f + 1);
              }}
            >
              <FaPlus /> Add Professional Supports
            </ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </>
  );
};
